import React, { useEffect, useState, useContext } from "react";
import { withRouter } from "react-router-dom";
import {
  GetAllUsersAPI,
  GetGroupByIdAsyncAPI,
} from "../../../../services/api/group-api";
import { GetDepartmentFiltersAPI } from "../../../../services/api/department-api";
import { LoginContext } from "../../../../services/api/authentication-api";
import "./admin-group-create-panel.scss";
import AdminGroupFormNew from "./admin-group-form-new";
import AdminGroupFormTopColumnNew from "./admin-group-form-top-column-new";

const AdminGroupCreatePanelNew = (props) => {
  const isEdit =
    props.location.pathname.split("/")[3] === "edit" ||
    props.location.pathname.split("/")[3] === "view";
  const isView = props.location.pathname.split("/")[3] === "view";
  const groupId = props.location.pathname.split("/")[4];
  const userContext = useContext(LoginContext);
  const currentUser = userContext?.currentUser;
  const isSuperAdmin = currentUser?.profile?.isSuperAdminRole ?? false;
  const userCompanyId =
    currentUser?.department?.CompanyID ?? currentUser?.department?.companyID ?? 0;
  const userCompanyName = currentUser?.department?.Name ?? "";

  const [departments, setDepartments] = useState([]);

  const [group, setGroup] = useState({
    data: {
      AllUsers: [],
      Members: [],
      Id: 0,
      Name: "",
      Description: "",
      Active: true,
      Created: new Date(),
      Deleted: false,
      StatusId: 1,
      Email: "",
      Modified: new Date(),
      ModifiedById: 0,
      Status: 0,
      Size: 0,
      SelectedAllMembers: false,
      SelectMemberScroll: 0,
      SelectMemberFilter: "",
      CompanyName: "",
      CompanyId: 0,
    },
    IsLoading: true,
  });

  const [alertConfig, setAlertConfig] = useState({
    showAlert: false,
    alertAction: "",
    alertMessage: "",
    alertVariant: "danger",
  });

  const [panelVisibility, setPanelVisibility] = useState({
    showCancelPanel: false,
    showConfirmPanel: false,
  });

  useEffect(() => {
    loadDepartments();
    if (!isEdit) LoadCreateGroup();
    else if (isEdit) LoadEditGroup();
  }, []);

  const canViewDepartments = currentUser?.privileges?.Department?.View ?? false;

  const loadDepartments = async () => {
    if (!canViewDepartments) {
      setDepartments([]);
      return;
    }
    try {
      const filters = await GetDepartmentFiltersAPI();
      setDepartments(filters?.data?.[0] ?? []);
    } catch (error) {
      setDepartments([]);
      setAlertConfig((prev) => ({
        ...prev,
        showAlert: true,
        alertAction: "Cannot Get Departments",
        alertMessage: error.toString(),
        alertVariant: "danger",
      }));
    }
  };

  const GetUsers = async () => {
    try {
      let users = await GetAllUsersAPI();
      let currentUser = users.data.find(
        (user) => user.Id === userContext.userID
      );
      return { users: users.data, currentUser };
    } catch (error) {
      setAlertConfig((prev) => ({
        ...prev,
        showAlert: true,
        alertAction: "Cannot get users for the group",
        alertMessage: error.toString(),
        alertVariant: "danger",
      }));
    }
  };

  const LoadCreateGroup = async () => {
    try {
      let userResult = await GetUsers();
      if (!userResult) return;

      let nongroupMembers = userResult.users.filter(
        (user) => userResult.currentUser.Id !== user.Id
      );
      let groupMembers = [userResult.currentUser];
      let allUsers = groupMembers.concat(nongroupMembers);

      setGroup((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          AllUsers: allUsers,
          Members: groupMembers,
          CreatorUserID: userContext.userID,
          SelectedAllMembers: nongroupMembers.length === 0,
          CompanyId: userCompanyId,
          CompanyName: userCompanyName,
        },
        IsLoading: false,
      }));
    } catch (error) {
      setGroup((prev) => ({ ...prev, IsLoading: false }));
      setAlertConfig((prev) => ({
        ...prev,
        showAlert: true,
        alertAction: "Cannot Load Group",
        alertMessage: error.toString(),
        alertVariant: "danger",
      }));
    }
  };

  const LoadEditGroup = async () => {
    try {
      let userResult = await GetUsers();
      if (!userResult) return;

      let groupResult = await GetGroupByIdAsyncAPI(groupId);

      let nongroupMembers = userResult.users.filter(
        (user) =>
          !groupResult.data.Members.find(({ UserId }) => user.Id === UserId)
      );
      let groupMembers = userResult.users.filter((user) =>
        groupResult.data.Members.find(({ UserId }) => user.Id === UserId)
      );
      let allUsers = groupMembers.concat(nongroupMembers);

      const { Members, ...rest } = groupResult.data;

      setGroup((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          ...rest,
          CompanyName: groupResult?.data?.CompanyName ?? "",
          CompanyId: groupResult?.data?.CompanyId ?? 0,
          Members: groupMembers,
          AllUsers: allUsers,
          SelectedAllMembers: nongroupMembers.length === 0,
        },
        IsLoading: false,
      }));
    } catch (error) {
      setGroup((prev) => ({ ...prev, IsLoading: false }));
      setAlertConfig((prev) => ({
        ...prev,
        showAlert: true,
        alertAction: "Cannot Get Group Details",
        alertMessage: error.toString(),
        alertVariant: "danger",
      }));
    }
  };

  return (
    <div className="group-edit-panel">
      <AdminGroupFormTopColumnNew
        alertConfig={alertConfig}
        setAlertConfig={setAlertConfig}
        panelVisibility={panelVisibility}
        setPanelVisibility={setPanelVisibility}
        isEdit={isEdit}
        isView={isView}
        Name={group.data.Name}
        history={props.history}
      />
      <AdminGroupFormNew
        group={group}
        setGroup={setGroup}
        isView={isView}
        isEdit={isEdit}
        setPanelVisibility={setPanelVisibility}
        setAlertConfig={setAlertConfig}
        isSuperAdmin={isSuperAdmin}
        departments={departments}
      />
    </div>
  );
};

export default withRouter(AdminGroupCreatePanelNew);
